var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 38C41.0523 38 41.5 38.4477 41.5 39C41.5 39.5523 41.0523 40 40.5 40H3.5C2.94772 40 2.5 39.5523 2.5 39C2.5 38.4477 2.94772 38 3.5 38H40.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9776 36.8569C37.1145 36.8569 38.8468 35.1065 38.8468 32.9474C38.8468 30.7882 37.1145 29.0378 34.9776 29.0378C32.8407 29.0378 31.1084 30.7882 31.1084 32.9474C31.1084 35.1065 32.8407 36.8569 34.9776 36.8569ZM34.9776 34.6229C35.8934 34.6229 36.6358 33.8727 36.6358 32.9474C36.6358 32.022 35.8934 31.2719 34.9776 31.2719C34.0618 31.2719 33.3194 32.022 33.3194 32.9474C33.3194 33.8727 34.0618 34.6229 34.9776 34.6229Z",
    fill: "#684BBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1103 14.0509C37.2324 14.051 38.2403 14.7397 38.6516 15.7865L40.953 21.3985C40.9827 21.4739 40.9988 21.5542 41.0006 21.6352L40.9997 31.225C41.0072 31.6082 40.6987 31.9231 40.3163 31.9231H40.0288C39.924 31.9231 39.8341 31.8485 39.8091 31.7456C39.276 29.5499 37.3153 27.9208 34.9778 27.9208C32.6403 27.9208 30.6796 29.5499 30.1465 31.7456C30.1215 31.8485 30.0316 31.9231 29.9267 31.9231H29.5227C29.1456 31.9231 28.8395 31.6171 28.8393 31.2391V14.736C28.8394 14.3579 29.1455 14.0509 29.5227 14.0509H36.1103ZM31.263 16.2304C30.8859 16.2304 30.5797 16.5374 30.5796 16.9155V21.2133C30.5799 21.5912 30.886 21.8973 31.263 21.8973H37.8473C38.3263 21.8969 38.6562 21.4151 38.4843 20.9668L36.8347 16.67C36.7332 16.4059 36.481 16.2307 36.1988 16.2304H31.263Z",
    fill: "#684BBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6283 27.7107C26.6283 27.5698 26.5026 27.4555 26.3476 27.4555H8.02246V31.9235H25.9266C26.3139 31.9235 26.6283 31.6377 26.6283 31.2854V27.7107Z",
    fill: "#684BBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6283 9.94329C26.6281 9.12756 26.0003 8.46635 25.226 8.46631H8.35411C8.17094 8.46631 8.02246 8.61634 8.02246 8.80141V14.5586V26.3384H26.2073C26.4396 26.3384 26.6282 26.1402 26.6283 25.8956V9.94329Z",
    fill: "#684BBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4736 0C16.6944 0.000189396 16.873 0.179594 16.873 0.400391V5.80078C16.873 6.02157 16.6944 6.20098 16.4736 6.20117H14.7002V11.7998C14.7002 12.0207 14.5207 12.2002 14.2998 12.2002H9.32812V33.9336C9.32812 34.1545 9.14865 34.334 8.92773 34.334H4.00195C3.78107 34.334 3.60156 34.1545 3.60156 33.9336V6.60059C3.60147 6.3798 3.42294 6.20124 3.20215 6.20117H0.400391C0.179484 6.20117 1.25814e-05 6.02168 0 5.80078V0.400391C0 0.179477 0.179477 0 0.400391 0H16.4736ZM9.72754 6.20117C9.50688 6.2014 9.32822 6.37989 9.32812 6.60059V9.7998H11.8994C12.1203 9.7998 12.2998 9.62033 12.2998 9.39941V6.20117H9.72754Z",
    fill: "#E8941C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutwardIcon);
export default __webpack_public_path__ + "static/media/outwardIcon.89e4a702472212fd5f8f29ae72311259.svg";
export { ForwardRef as ReactComponent };